import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useClass } from "../../../globals/ClassContext";
import axios from "axios";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useSetAssignmentReview } from "../../../globals/AssignmentReviewContext";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

//First we need to load the class object
//Then we need to load all the assignment objects from the class (Used to see assignment name).
//We also need to load each student object in the class.

//Create an accordian that has an accrodian for each assignment in the class.
//Inside each accordian we will have table displaying each students name and their grade for that class.

//We can also create an additional "assignment" that stores each students total class grade.

export default function AdminGrades({ setPage }) {
  const classroom = useClass();
  const assignments = classroom.assignments;
  const students = classroom.students;
  const setAssignmentReview = useSetAssignmentReview();

  const [assignmentGrades, setAssignmentGrades] = useState([]);
  const [studentObjects, setStudentObjects] = useState([]);
  const [classMaxPoints, setClassMaxPoints] = useState([]);

  //We need to look at all the assignments for the class, make sure the attempts belong to this class

  useEffect(() => {
    if (assignments && assignments.length > 0) {
      const fetchData = async () => {
        const assignmentGradeObjects = [];
        const requests = assignments.map((assignment) =>
          axios.get(`${REACT_APP_DEBUGGER_SERVER_URL}/assignment/${assignment}`)
        );
        const responses = await axios.all(requests);
        const assignmentObjects = responses.map((response) => response.data);
        let studentObjects = [];
        if (students) {
          const requests1 = students.map((student) =>
            axios.get(`${REACT_APP_DEBUGGER_SERVER_URL}/user/${student}`)
          );
          const responses1 = await axios.all(requests1);
          studentObjects = responses1.map((response) => response.data);
          studentObjects.forEach((student) => {
            student.classGrade = 0;
          });
        } else {
          studentObjects = [];
        }
        //for each assignment
        let classMaxPoints = 0;

        for (let i = 0; i < assignmentObjects.length; i++) {
          const maxPoints = assignmentObjects[i].points
            ? assignmentObjects[i].points
            : 0;
          classMaxPoints += maxPoints;
          //for each student
          const studentGrades = [];
          for (let x = 0; x < studentObjects.length; x++) {
            let attempt = {};
            let grade = 0;
            let status = "Not Started";
            if (studentObjects[x].assignment_attempts) {
              attempt = studentObjects[x].assignment_attempts.find(
                (obj) => obj.assignment === assignmentObjects[i]._id
              );
            }
            if (attempt) {
              grade = attempt.pointsEarned ? attempt.pointsEarned : 0;
              if (attempt.isCompleted) {
                status = "Submitted";
              } else {
                status = "Work in Progress";
              }
            }
            studentObjects[x].classGrade += grade;
            const student = {
              name: studentObjects[x].name,
              status: status,
              grade: grade,
              _id: studentObjects[x]._id,
            };
            studentGrades.push(student);
          }
          const assignmentGrades = {
            name: assignmentObjects[i].name,
            students: studentGrades,
            maxPoints: maxPoints,
            _id: assignmentObjects[i]._id,
          };
          assignmentGradeObjects.push(assignmentGrades);
        }
        setClassMaxPoints(classMaxPoints);
        setStudentObjects(studentObjects);
        setAssignmentGrades(assignmentGradeObjects);
      };
      fetchData();
    } else {
      setAssignmentGrades([]);
      setStudentObjects([]);
      setClassMaxPoints(0);
    }
  }, [assignments, students]);

  const handleStudentClick = (student, assignment) => {
    const assignmentReview = {
      userID: student._id,
      assignmentID: assignment._id,
    };
    setAssignmentReview(() => assignmentReview);
    setPage("assignmentReview");
  };

  return (
    <>
      <div>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            fontSize={24}
            align="center"
            //sx={{ pb: "15px" }}
          >
            <Typography>Total Grades</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 100 }} size="small" aria-label="Grades">
                <TableHead>
                  <TableRow>
                    <TableCell>Student Name:</TableCell>
                    {/* <TableCell align="right">Date Completed:</TableCell> */}
                    <TableCell align="right">Points:</TableCell>
                    <TableCell align="right">Grade:</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {studentObjects.map((row) => (
                    <TableRow key={row.name}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">
                        {row.classGrade + "/" + classMaxPoints}
                      </TableCell>
                      <TableCell align="right">
                        {(!isNaN(row.classGrade / classMaxPoints)
                          ? (row.classGrade / classMaxPoints * 100).toFixed(2) 
                          : 0) + "%"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
        {assignmentGrades.map((assignment) => (
          <Accordion key={assignment.name}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={assignment.name + "-content"}
              id={assignment.name + "-header"}
              fontSize={24}
              align="center"
              //sx={{ pb: "15px" }}
            >
              <Typography>{assignment.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 100 }} size="small" aria-label="Grades">
                  <TableHead>
                    <TableRow>
                      <TableCell>Student Name:</TableCell>
                      <TableCell align="right">Status:</TableCell>
                      <TableCell align="right">Points:</TableCell>
                      <TableCell align="right">Grade:</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {assignment.students.map((student) => (
                      <TableRow key={student.name}>
                        <TableCell component="th" scope="row">
                          {student.name}
                        </TableCell>
                        <TableCell align="right">{student.status}</TableCell>
                        <TableCell align="right">
                          {student.grade + "/" + assignment.maxPoints}
                        </TableCell>
                        <TableCell align="right">
                          {(!isNaN(student.grade / assignment.maxPoints)
                            ? (student.grade / assignment.maxPoints * 100).toFixed(
                                2
                              ) 
                            : 0) + "%"}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              handleStudentClick(student, assignment)
                            }
                          >
                            Review
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </>
  );
}
